import { render, staticRenderFns } from "./SidebarToggle.vue?vue&type=template&id=48a35f7e&scoped=true&"
import script from "./SidebarToggle.vue?vue&type=script&lang=js&"
export * from "./SidebarToggle.vue?vue&type=script&lang=js&"
import style0 from "./SidebarToggle.vue?vue&type=style&index=0&id=48a35f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a35f7e",
  null
  
)

export default component.exports